import { render, staticRenderFns } from "./SummitDetail.vue?vue&type=template&id=6311edf7&scoped=true"
import script from "./SummitDetail.vue?vue&type=script&lang=js"
export * from "./SummitDetail.vue?vue&type=script&lang=js"
import style0 from "./SummitDetail.vue?vue&type=style&index=0&id=6311edf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311edf7",
  null
  
)

export default component.exports